export default __webpack_public_path__ + "static/media/36I-117138_-37279_0.c6eaff64.jpg";